export default __webpack_public_path__ + "static/media/Battery_failure.eba13616.svg";